import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

// Normalize a cost field: accepts a number or {low, high, avg} object → object.
export function asRange(value) {
    if (value && typeof value === "object" && !Array.isArray(value)) {
        const low = Number(value.low ?? value.avg ?? 0);
        const high = Number(value.high ?? value.avg ?? 0);
        const avg = Number(value.avg ?? Math.round((low + high) / 2));
        return { low, high, avg };
    }
    const n = Number(value || 0);
    return { low: n, high: n, avg: n };
}

export function formatRange(value, { compact = false } = {}) {
    const r = asRange(value);
    if (r.low === r.high) return `$${r.low.toLocaleString()}`;
    const sep = compact ? "–" : " – ";
    return `$${r.low.toLocaleString()}${sep}$${r.high.toLocaleString()}`;
}

// In-flight pre-fetch cache for search results (UX speed)
const prefetchCache = new Map();
export function prefetchSearch({ destination, days = 5, travelers = 2, budget_level = "mid" }) {
    const key = `${destination.toLowerCase().trim()}|${days}|${travelers}|${budget_level}`;
    if (!destination || prefetchCache.has(key)) return prefetchCache.get(key);
    const p = api.post("/search", { destination, days, travelers, budget_level })
        .then((r) => r.data)
        .catch(() => null);
    prefetchCache.set(key, p);
    return p;
}
